import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "copyright-area bg-primary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "container" }, [
      _createElementVNode("div", { class: "row" }, [
        _createElementVNode("p", null, [
          _createTextVNode(" © "),
          _createElementVNode("span", null, "GoPlayTv")
        ])
      ])
    ], -1)
  ])))
}